import React from 'react';
import type { VariableInfo } from './templateSections';

interface VariableChipBarProps {
  variables: VariableInfo[];
  onInsert: (variableToken: string) => void;
}

const VariableChipBar: React.FC<VariableChipBarProps> = ({ variables, onInsert }) => {
  if (variables.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5">
      {variables.map((v) => (
        <button
          key={v.name}
          type="button"
          onClick={() => onInsert(`{{${v.name}}}`)}
          className="inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full
            bg-purple-50 text-purple-700 border border-purple-200
            hover:bg-purple-100 hover:border-purple-300
            transition-colors cursor-pointer select-none"
          title={`${v.description} (e.g. ${v.sampleValue})`}
        >
          <span className="font-mono text-[11px] mr-1 text-purple-500">{'{{'}</span>
          {v.label}
          <span className="font-mono text-[11px] ml-1 text-purple-500">{'}}'}</span>
        </button>
      ))}
    </div>
  );
};

export default VariableChipBar;
